var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-field-library",
      style: _vm.isReduceBlur ? "background-color: rgba(255,255,255,0.9);" : "",
      attrs: { id: "modalFieldLibrary" }
    },
    [
      _c("div", { staticClass: "modal-field-title" }, [
        _vm._v(_vm._s(_vm.isComponent ? "COMPONENT" : "TOOLBOX"))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-field-content" }, [
        _c("div", { staticClass: "input-search" }, [
          _c("i", { staticClass: "fa fa-search" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchField,
                expression: "searchField"
              }
            ],
            attrs: { type: "text", placeholder: "Search", autocomplete: "off" },
            domProps: { value: _vm.searchField },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchField = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wrap-field" },
          _vm._l(_vm.fieldsLibrary, function(fields) {
            return _c(
              "div",
              { key: fields.section, staticClass: "field-section" },
              [
                fields.section
                  ? _c("p", { staticClass: "title-section" }, [
                      _vm._v(
                        "\n          " + _vm._s(fields.section) + "\n        "
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isLoading
                  ? _c("j-skeleton-field-library")
                  : _c(
                      "div",
                      { staticClass: "field-list" },
                      _vm._l(fields.fields, function(field) {
                        return _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.hideFieldByConfig(field.type),
                                expression: "hideFieldByConfig(field.type)"
                              }
                            ],
                            key: field.type,
                            staticClass: "list",
                            attrs: { id: field.type },
                            on: {
                              click: function($event) {
                                _vm.selectField(field)
                              }
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "field-icon field-icon-active",
                              attrs: {
                                src: require("@/assets/new-form-ui/field-icon-active/" +
                                  field.type +
                                  ".svg")
                              }
                            }),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "field-icon field-icon-default",
                              attrs: {
                                src: require("@/assets/new-form-ui/field-icon/" +
                                  field.type +
                                  ".svg")
                              }
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(field.name))])
                          ]
                        )
                      })
                    )
              ],
              1
            )
          })
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-field-footer" }, [
        _c(
          "button",
          {
            on: {
              click: function($event) {
                _vm.$emit("close-modal")
              }
            }
          },
          [_vm._v("Close")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-36e1e491", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e1e491","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/ModalFieldLibrary.vue
// module id = null
// module chunks = 